'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.integrateServicesFor = exports.integrateAll = undefined;

var _bugsnag = require('./bugsnag');

Object.keys(_bugsnag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bugsnag[key];
    }
  });
});

var _googleAnalytics = require('./google-analytics');

Object.keys(_googleAnalytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _googleAnalytics[key];
    }
  });
});

var _heapAnalytics = require('./heap-analytics');

Object.keys(_heapAnalytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _heapAnalytics[key];
    }
  });
});

var _eventLogger = require('./event-logger.js');

Object.keys(_eventLogger).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _eventLogger[key];
    }
  });
});

var _launchdarkly = require('./launchdarkly.js');

Object.keys(_launchdarkly).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _launchdarkly[key];
    }
  });
});

var _qualaroo = require('./qualaroo');

Object.keys(_qualaroo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _qualaroo[key];
    }
  });
});

var _apollo = require('./apollo');

Object.keys(_apollo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _apollo[key];
    }
  });
});

var _fullstory = require('./fullstory');

Object.keys(_fullstory).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fullstory[key];
    }
  });
});

var _walkme = require('./walkme');

Object.keys(_walkme).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _walkme[key];
    }
  });
});

var _configuration = require('./configuration');

var _eventLogger2 = require('./event-logger');

var _configuration2 = require('@quid-private/quid-client/lib/configuration');

var _launchdarkly2 = require('./launchdarkly');

var _zendeskChat = require('./zendesk-chat');

function integrateAll() {
  return integrateServicesFor();
}

function integrateServicesFor() {
  var $args = arguments;
  return new Promise(function ($return, $error) {
    var stackName, customData, data, config, userId, clientId, zendeskChat, walkMeVariables, errorMessage;
    stackName = $args.length > 0 && $args[0] !== undefined ? $args[0] : 'all';
    customData = $args[1];

    if (stackName != null && customData != null) {
      // eslint-disable-next-line no-console
      console.error('You are attempting to call `integrateServicesFor` with both a `stackName` ' + 'and a `customData` argument, please provide only one of them (set the other to `null` or `undefined`).');
    } // Initalize all the plugins that can be initialized without configuration


    _heapAnalytics.HeapAnalytics.initialize();

    var $Try_1_Post = function $Try_1_Post() {
      try {
        return $return();
      } catch ($boundEx) {
        return $error($boundEx);
      }
    };

    var $Try_1_Catch = function $Try_1_Catch(error) {
      try {
        errorMessage = error.toString();

        if (errorMessage.includes('Error') && errorMessage.includes('Network')) {
          error.networkError = true;
        }

        throw error;
      } catch ($boundEx) {
        return $error($boundEx);
      }
    };

    try {
      return Promise.resolve(new Promise(function ($return, $error) {
        var $logicalOr_2;

        if (!($logicalOr_2 = customData)) {
          return Promise.resolve((0, _configuration2.fetchConfigFor)(stackName)).then(function ($await_4) {
            try {
              $logicalOr_2 = $await_4;
              return $If_3.call(this);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this), $error);
        }

        function $If_3() {
          return $return($logicalOr_2);
        }

        return $If_3.call(this);
      })).then(function ($await_5) {
        try {
          data = $await_5;
          config = new _configuration.Configuration(data);
          userId = config.getUserId();
          clientId = config.getClientID();
          zendeskChat = new _zendeskChat.ZendeskChat();

          if (config.isBugsnagEnabled()) {
            _bugsnag.Bugsnag.initialize(config.getBugsnagApiKey(), userId, config.getEnvironment());
          }

          if (config.isGoogleAnalyticsEnabled()) {
            _googleAnalytics.GoogleAnalytics.initialize(config.getGoogleAnalyticsTrackingId(), userId);
          }

          if (config.isHeapAnalyticsEnabled()) {
            _heapAnalytics.HeapAnalytics.configure(config.getHeapAnalyticsApiKey(), userId);

            _eventLogger2.EventLogger.addService(_heapAnalytics.HeapAnalytics);
          }

          if (config.isLaunchDarklyEnabled()) {
            _launchdarkly2.LaunchDarkly.initialize(config.getFeatureFlagData());
          }

          if (config.isQualarooEnabled()) {
            _qualaroo.Qualaroo.initialize({
              clientId: config.getQualarooClientId(),
              userCreatedDate: config.getUserCreatedDate(),
              userId: userId
            });
          }

          if (config.isFullstoryEnabled()) {
            _fullstory.Fullstory.initialize(config.getFullstoryConfig());
          }

          if (config.isWalkMeEnabled()) {
            walkMeVariables = {
              clientId: clientId,
              userId: userId
            };

            _walkme.WalkMe.initialize({
              environment: config.getEnvironment(),
              api_key: config.getWalkMeApiKey(),
              walkMeVariables: walkMeVariables
            });
          }

          if (config.isZendeskChatEnabled()) {
            zendeskChat.initialize();

            if (config.isZendeskChatHidden()) {
              zendeskChat.getInstance().hide();
            }

            zendeskChat.getInstance().prefillForm(config.getFullName(), config.getEmail());
          }

          return $return({
            Bugsnag: _bugsnag.Bugsnag,
            GoogleAnalytics: _googleAnalytics.GoogleAnalytics,
            HeapAnalytics: _heapAnalytics.HeapAnalytics,
            EventLogger: _eventLogger2.EventLogger,
            LaunchDarkly: _launchdarkly2.LaunchDarkly,
            Qualaroo: _qualaroo.Qualaroo,
            Fullstory: _fullstory.Fullstory,
            WalkMe: _walkme.WalkMe,
            ZendeskChat: zendeskChat.getInstance(),
            homeUrl: data.home_url || null
          });
        } catch ($boundEx) {
          return $Try_1_Catch($boundEx);
        }
      }, $Try_1_Catch);
    } catch (error) {
      $Try_1_Catch(error);
    }
  });
}

exports.integrateAll = integrateAll;
exports.integrateServicesFor = integrateServicesFor;